module.exports = __webpack_public_path__ + "img/page2bg.fb0191da.png";